//
//
//
//
//
//
//
//
//
//

export default {
    methods: {
        toggleDlg () {
            this.$emit('toggleDlg', !this.show)
        },
        confirm () {
            this.toggleDlg()
            this.$emit('confirm')
        }
    },
    props: {
        title: {
            type: String
        },
        content: {
            type: String
        },
        show: {
            type: Boolean
        },
        className: {
            type: String,
            default: ''
        },
        show_confirm: {
            type: Boolean,
            default: true
        }
    }
}
